import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component(
    {
        name: 'incidentsTable',
        props: {
            tableData: Object
        },
        watch: {
            tableData: function () {
                this.$forceUpdate();
            }
        }
    }
)
export default class IncidentsTableComponent extends Vue {
    name: string = "";
    id: string = "";
    tableData: any;

    mounted() {
        this.id = "table_div";
    }

    updated() {
        this.name = this.$props.tableData.name;
        console.log(this.tableData);
    }

}